export default {
    key: 'meet-the-team',
    label: 'Meet the team',
    component: {
        name: 'MeetTheTeamTemplate',
        loader: () => import('./MeetTheTeamTemplate')
    },
    modules: {
        locations: [
            {
                label: 'Primary modules',
                name: 'primary'
            },
            {
                label: 'Secondary modules',
                name: 'secondary'
            }
        ]
    }
};
